export function heroSectionSlider() {
    let slider = $(".hero-section-slider");
    slider.slick({
        arrows: false,
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        speed: 400,
        fade: true,
        cssEase: 'ease-in-out',
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroSectionSlider.js